import { styled } from 'styled-components';
import { PASSING_KEY_SIZE } from './PassingKey.constants';

export const PassingKeySVG = styled.svg`
  max-width: ${PASSING_KEY_SIZE.WIDTH}px;
`;
